import { configureStore } from '@reduxjs/toolkit';
import pages from './pages/slice';
import children from './child/slice';
import game from './game/slice';
import sound from './sound/slice';
import hooks from './hooks/slice';
import { useDispatch } from 'react-redux';

const store = configureStore({
  reducer: { pages, children, game, sound, hooks },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
